import React from "react";
import "./CertificateGroupingApprove.scss";
import CertificateGroupingListApprove from "../../features/CertificateGroupingListApprove/CertificateGroupingListApprove";

const CertificateGroupingApprove = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListApprove />
    </div>
  );
};

export default CertificateGroupingApprove;
